var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _g2, _path27, _path28, _path29, _g3, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g4, _path39, _g5, _path40, _g6, _path41, _g7, _path42, _g8, _path43, _g9, _path44, _g0, _path45, _g1, _path46, _g10, _path47, _g11, _path48, _g12, _path49, _g13, _path50, _g14, _path51, _g15, _path52, _g16, _path53, _g17, _path54, _g18, _path55, _g19, _path56, _g20, _path57, _g21, _path58, _g22, _path59, _g23, _path60, _g24, _path61, _g25, _path62, _g26, _path63, _g27, _path64, _g28, _path65, _g29, _path66, _g30, _path67, _g31, _path68, _g32, _path69, _g33, _path70, _g34, _path71, _g35, _path72, _g36, _path73, _g37, _path74, _g38, _path75, _g39, _path76, _g40, _path77, _g41, _path78, _g42, _path79, _g43, _path80, _g44, _path81, _g45, _path82, _g46, _path83, _g47, _path84, _g48, _path85, _g49, _path86, _g50, _path87, _g51, _path88, _g52, _path89, _g53, _path90, _g54, _path91, _g55, _path92, _g56, _path93, _g57, _path94, _g58, _path95, _g59, _path96, _g60, _path97, _g61, _path98, _g62, _path99, _g63, _path100, _g64, _path101, _g65, _path102, _g66, _path103, _g67, _path104, _g68, _path105, _g69, _path106, _g70, _path107, _g71, _path108, _g72, _path109, _g73, _path110, _g74, _path111, _g75, _path112, _g76, _path113, _g77, _path114, _g78, _path115, _g79, _path116, _g80, _path117, _g81, _path118, _g82, _path119, _g83, _path120, _g84, _path121, _g85, _path122, _g86, _path123, _g87, _path124, _g88, _path125, _g89, _path126, _g90, _path127, _g91, _path128, _g92, _path129, _g93, _path130, _g94, _path131, _g95, _path132, _g96, _path133, _g97, _path134, _g98, _path135, _g99, _path136, _g100, _path137, _g101, _path138, _g102, _path139, _g103, _path140, _g104, _path141, _g105, _path142, _g106, _path143, _g107, _path144, _g108, _path145, _g109, _path146, _g110, _path147, _g111, _path148, _g112, _path149, _g113, _path150, _g114, _path151, _g115, _path152, _g116, _path153, _g117, _path154, _g118, _path155, _g119, _path156, _g120, _path157, _g121, _path158, _g122, _path159, _g123, _path160, _g124, _path161, _g125, _path162, _g126, _path163, _g127, _path164, _g128, _path165, _g129, _path166, _g130, _path167, _g131, _path168, _g132, _path169, _g133, _path170, _g134, _path171, _g135, _path172, _g136, _path173, _g137, _path174, _g138, _path175, _g139, _path176, _g140, _path177, _g141, _path178, _g142, _path179, _g143, _path180, _g144, _path181, _g145, _path182, _g146, _path183, _g147, _path184, _g148, _path185, _g149, _path186, _g150, _path187, _g151, _path188, _g152, _path189, _g153, _path190, _g154, _path191, _g155, _path192, _g156, _path193, _g157, _path194, _g158, _path195, _g159, _path196, _g160, _path197, _g161, _path198, _g162, _path199, _g163, _path200, _g164, _path201, _g165, _path202, _g166, _path203, _g167, _path204, _g168, _path205, _g169, _path206, _g170, _path207, _g171, _path208, _g172, _path209, _g173, _path210, _g174, _path211, _g175, _path212, _g176, _path213, _g177, _path214, _g178, _path215, _g179, _path216, _g180, _path217, _g181, _path218, _g182, _path219, _g183, _path220, _g184, _path221, _g185, _path222, _g186, _path223, _g187, _path224, _g188, _path225, _g189, _path226, _g190, _path227, _g191, _path228, _g192, _path229, _g193, _path230, _g194, _path231, _g195, _path232, _g196, _path233, _g197, _path234, _g198, _path235, _g199, _path236, _g200, _path237, _g201, _path238, _g202, _path239, _g203, _path240, _g204, _path241, _g205, _path242, _g206, _path243, _g207, _path244, _g208, _path245, _g209, _path246, _g210, _path247, _g211, _path248, _g212, _path249, _g213, _path250, _g214, _path251, _g215, _path252, _g216, _path253, _g217, _path254, _g218, _path255, _g219, _path256, _g220, _path257, _g221, _path258, _g222, _path259, _g223, _path260, _g224, _path261, _g225, _path262, _g226, _path263, _g227, _path264, _path265, _path266, _path267, _g228, _g229, _path268, _path269, _path270, _g230, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 230,
    viewBox: "0 0 266 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.374 54.2082C86.7364 44.3525 86.7364 28.3731 78.374 18.5174C70.0115 8.6616 56.4533 8.6616 48.0908 18.5174C39.7283 28.3731 39.7283 44.3525 48.0908 54.2082C56.4533 64.064 70.0115 64.064 78.374 54.2082Z",
    fill: "#7DB5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8001 41.692C72.13 41.692 70.6854 42.8448 70.0134 44.5075L60.9666 43.0686C60.8953 41.1419 60.1638 39.4128 59.0314 38.1854L64.1461 29.5128C64.7453 29.8116 65.4036 29.977 66.0947 29.977C68.8482 29.977 71.0886 27.349 71.0886 24.1184C71.0886 20.8878 68.8482 18.2598 66.0947 18.2598C63.3411 18.2598 61.1008 20.8881 61.1008 24.1184C61.1008 25.501 61.5113 26.773 62.1967 27.7761L56.9323 36.7026C56.31 36.4469 55.6415 36.3074 54.9453 36.3074C51.6219 36.3074 48.918 39.4795 48.918 43.3784C48.918 47.2773 51.6219 50.4494 54.9453 50.4494C57.4818 50.4494 59.6572 48.6014 60.5453 45.9933L69.673 47.4453C70.0134 49.756 71.7345 51.5193 73.7998 51.5193C76.1091 51.5193 77.988 49.315 77.988 46.6056C77.988 43.8963 76.1098 41.692 73.8001 41.692Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2214 59.2332C70.1409 59.1252 70.0597 59.0108 70.027 58.8717C69.9315 58.466 70.2688 58.112 70.4231 57.7287C70.5218 57.4838 70.5462 57.209 70.5692 56.9401C70.6089 56.4773 70.6484 56.015 70.6882 55.5522C70.6948 55.4746 70.7012 55.3932 70.6764 55.3212C70.6538 55.2556 70.6083 55.2057 70.5634 55.1596C70.0932 54.6758 69.4842 54.3252 68.8586 54.3961C68.2502 54.4655 67.7132 54.9222 67.3021 55.4626C67.0386 55.8091 66.8133 56.1953 66.6336 56.6093C66.5776 56.738 66.5251 56.8745 66.5235 57.0181C66.5222 57.1358 66.555 57.2494 66.5909 57.359C66.8162 58.0482 67.1691 58.6767 67.618 59.1882C67.8726 59.4781 68.1628 59.7383 68.3371 60.1028C68.4593 60.3582 68.5166 60.6488 68.5821 60.9323C68.7138 61.5008 68.8857 62.0558 69.0947 62.5898C69.1364 62.6963 70.6586 61.0827 70.7779 60.9173C71.3255 60.1595 70.6777 59.8463 70.2214 59.2332Z",
    fill: "#EACDB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.427 85.1336C79.7888 85.5401 80.1566 85.9294 80.5298 86.2984C80.9393 86.7038 81.3641 87.1103 81.8684 87.3225C82.3457 87.5239 82.8668 87.5385 83.3753 87.5018C85.5895 87.3401 88.7513 85.968 88.3447 82.8128C88.2228 81.867 87.7538 81.0458 87.2743 80.2808C85.9513 78.1695 84.4574 76.2188 82.9664 74.2721C78.9793 69.0668 74.9922 63.8614 71.0053 58.656C69.956 59.5478 68.9066 60.4395 67.8573 61.3313C67.001 62.0588 71.1877 71.6486 71.6913 72.7181C73.7032 76.9909 76.3549 81.6833 79.427 85.1336Z",
    fill: "#3B455A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6168 67.9032C82.1949 67.4382 82.8975 67.016 83.5886 66.641C89.1599 63.6203 95.3747 62.2377 101.496 62.7301C105.676 63.0665 109.777 64.2432 113.793 65.6476C115.346 66.1906 116.92 66.7853 118.233 67.9032C119.546 69.0211 120.576 70.7626 120.59 72.6713C109.827 74.0056 99.3742 75.1096 88.5023 74.5265C86.4159 74.4147 83.7391 73.5102 81.9442 72.2866C79.4573 70.592 80.1233 69.1043 81.6168 67.9032Z",
    fill: "#3B455A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0502 66.347C99.2475 66.2398 99.4228 66.0905 99.5571 65.8813C99.5895 65.831 99.6194 65.7763 99.6293 65.714C99.6411 65.6409 99.6242 65.5663 99.6077 65.4947C99.544 65.2209 98.8905 63.1022 99.0362 62.9949C100.156 62.2513 101.111 61.0003 101.664 59.7073C102.697 57.2923 102.751 54.5349 102.549 51.9399C102.26 48.2102 101.178 44.1215 98.2859 42.755C96.0685 41.7065 93.2857 42.848 91.4982 44.8325C89.1996 47.3848 89.5522 51.59 90.0377 54.8323C90.3849 57.1505 91.2175 59.45 92.5816 61.1735C93.2669 62.0398 94.0926 62.7482 95.023 63.1862C95.4748 63.3988 95.8961 63.3553 96.0307 63.8923C96.1974 64.5575 96.1159 65.5449 96.1688 66.2537C96.1777 66.371 96.1926 66.5027 96.2712 66.5735C96.3278 66.6245 96.4033 66.6302 96.4739 66.6335C96.9585 66.656 97.444 66.6508 97.928 66.6178C98.3066 66.5912 98.7113 66.5312 99.0502 66.347Z",
    fill: "#EACDB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6504 47.8666C100.779 48.6586 101.884 50.0052 101.677 51.5502C102.27 51.1988 103.005 51.8873 103.091 52.6707C103.176 53.4541 102.812 54.2074 102.388 54.8138C103.049 54.9469 103.698 54.3773 103.999 53.6614C104.3 52.9456 104.33 52.1153 104.342 51.3143C104.376 48.9383 104.29 46.4982 103.525 44.3048C102.76 42.1114 101.191 40.1884 99.2288 39.8108C98.6239 39.6946 98.0057 39.7261 97.3967 39.8048C96.9019 39.8689 96.3973 39.9694 95.9668 40.2676C92.4579 42.6949 98.1899 46.8413 99.6504 47.8666Z",
    fill: "#3B455A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5396 52.5473C90.9582 54.3964 92.3519 56.4304 91.9911 58.3583C91.7667 59.5568 90.8863 60.5359 90.8889 61.7641C90.8921 63.3499 92.363 64.5151 92.3796 66.1009C91.537 64.8368 89.9254 64.5297 89.1936 63.1707C88.892 62.6108 88.7809 61.9384 88.5706 61.3216C87.7058 58.7836 85.3713 57.5524 83.4014 56.1511C83.1723 55.9879 82.9366 55.8091 82.802 55.5338C82.5042 54.9256 82.8125 54.1707 83.0667 53.5347C83.8377 51.6068 84.111 49.3996 83.8405 47.2872C83.5831 45.2757 82.8462 43.2739 83.1809 41.2786C83.4787 39.5026 84.6866 37.9921 86.1569 37.5556C87.4812 37.1626 88.9015 37.5893 90.228 37.2079C91.1084 36.9548 91.8889 36.3623 92.7095 35.9048C94.6068 34.8466 97.1087 34.6309 98.5835 36.4073C99.8871 37.9778 99.8966 40.6249 99.0413 42.5873C98.5131 43.7993 97.7597 44.8444 97.2245 46.0546C96.8134 46.9846 96.521 48.0038 95.8474 48.7253C94.5512 50.1139 92.2186 50.3873 91.5396 52.5473Z",
    fill: "#3B455A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.82 89.4555L188.191 90.0318L186.294 88.4077L185.795 88.7163L186.081 89.4577L184.176 88.6522L182.622 89.3283L182.012 91.8457L182.853 94.3376L185.008 94.7606L187.456 93.6648L191.081 93.0611L190.82 89.4555Z",
    fill: "#EACDB0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M189.161 88.3791C191.885 87.0805 194.61 85.7815 197.335 84.4829C199.093 83.6444 200.871 82.846 202.615 81.9659C204.808 80.8596 204.195 79.0506 205.49 76.7594C208.405 71.6035 211.69 66.1068 216.696 64.216C217.196 64.027 217.732 63.8774 218.243 64.0206C219.209 64.2918 219.777 65.5634 219.757 66.7341C219.738 67.9049 219.273 68.9935 218.811 70.0304C216.307 75.652 213.735 82.4418 210.202 87.271C208.614 89.4419 204.868 89.7513 202.51 90.4686C197.74 91.9199 192.97 93.3711 188.199 94.8224L189.161 88.3791Z",
    fill: "#305399"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M215.839 212.49V215.103L210.155 218.452L207.312 215.103L210.155 211.753H210.521L210.613 212.49H215.839Z",
    fill: "#41352B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.839 211.753H230.231L233.074 215.103L230.231 218.452L224.547 215.103V212.49H229.773L229.839 211.753Z",
    fill: "#41352B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.762 134.587C198.118 130.188 198.487 125.79 198.939 121.403C199.84 112.654 201.066 103.925 203.14 95.4549C203.932 92.2191 204.846 89.0286 205.76 85.8388C206.873 81.9549 207.986 78.0707 209.098 74.1868C210.481 69.3594 212.815 65.9589 216.903 64.2703C217.633 63.9688 218.401 63.7359 219.193 63.5657C219.212 63.6654 219.23 63.7667 219.241 63.8732C219.288 64.3367 219.399 64.8508 219.643 65.1872L216.961 65.2179C216.961 65.2179 209.392 96.9197 209.114 102.383C209.008 104.46 208.656 108.994 208.265 113.771L204.155 114.496L203.979 132.766C203.749 132.845 203.52 132.922 203.293 132.994C201.989 133.408 200.928 134.548 199.845 135.441C198.245 136.761 197.543 137.283 197.762 134.587Z",
    fill: "#305399"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.267 113.771C207.647 121.33 206.929 129.496 206.929 129.496C206.929 129.496 210.252 129.59 215.059 130.02C214.704 130.01 214.348 129.999 213.993 129.995C210.649 129.96 207.182 131.662 203.98 132.766L204.157 114.496L208.267 113.771Z",
    fill: "#305399"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.7 132.319C232.992 132.463 233.277 131.954 233.277 131.954C233.277 131.954 231.21 122 229.758 113.342L236.303 114.497L236.388 135.169C235.833 134.751 235.257 134.353 234.636 133.999C233.392 133.289 232.063 132.748 230.7 132.319Z",
    fill: "#145566"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.979 132.766C207.18 131.662 210.648 129.96 213.991 129.995C214.346 129.999 214.702 130.01 215.057 130.02C215.355 130.047 215.658 130.075 215.966 130.104C218.207 130.316 220.724 130.6 223.352 130.976C223.481 130.994 223.61 131.012 223.739 131.031C227.101 131.893 229.283 132.23 230.7 132.319C232.063 132.748 233.392 133.289 234.636 133.999C235.257 134.353 235.832 134.75 236.388 135.169L236.405 139.473L229.997 212.589H224.742V213.333H224.712L218.934 164.29L218.91 164.014L215.745 213.333H215.715V212.589H210.435L203.738 157.669L203.979 132.766Z",
    fill: "#1A3151"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.898 113.002C226.15 108.539 225.565 104.421 225.511 102.187C225.35 95.4696 224.633 73.2839 224.633 73.2839L221.154 64.7976L220.512 64.8051C220.558 64.7987 220.604 64.792 220.65 64.7856C220.499 64.8066 220.723 63.1457 220.777 62.9991C223.802 62.8776 227.7 64.8884 229.608 67.69C231.02 69.763 231.859 72.2972 232.677 74.7872C234.979 81.7979 236.024 88.2929 237.173 95.6646C237.905 100.365 238.582 105.044 239.115 109.71C239.704 114.878 240.12 120.031 240.241 125.154C240.254 125.72 240.349 127.304 240.403 129.196C240.515 133.159 240.443 138.459 239.051 138.657C238.79 138.694 238.539 138.556 238.31 138.422C236.519 137.38 235.108 136.018 233.529 134.828L229.32 120.5L226.898 113.002Z",
    fill: "#305399"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.93 129.497C206.93 129.497 210.147 129.591 214.8 130.021C215.088 130.047 215.382 130.075 215.68 130.104C217.849 130.317 220.286 130.6 222.83 130.976C222.955 130.995 223.079 131.013 223.205 131.032C225.467 131.631 227.606 132.267 229.927 132.426C230.802 132.487 231.742 133.34 232.428 132.585C233.007 131.949 232.748 129.199 232.748 128.373C232.75 125.123 232.345 121.894 231.791 118.717C230.641 112.111 228.786 105.676 228.089 98.9625C227.837 96.5254 227.742 94.0684 227.48 91.6327C226.866 85.926 225.501 80.5954 225.027 74.8725C224.93 73.7002 224.574 64.8926 222.841 65.1465C221.985 65.2717 221.129 65.3974 220.273 65.5226C220.051 65.5552 219.821 65.5867 219.608 65.5001C219.502 65.4566 219.409 65.3887 219.329 65.3025C219.296 65.2676 219.267 65.2282 219.239 65.1881L216.642 65.2189C216.642 65.2189 209.314 96.9206 209.045 102.384C208.943 104.461 208.603 108.995 208.224 113.772C207.625 121.33 206.93 129.497 206.93 129.497Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M214.525 43.932C213.792 45.6746 213.487 47.6482 213.499 49.5997C213.502 50.1187 213.498 50.7184 213.162 51.0454C212.802 51.3956 213.162 52.0931 212.859 51.6731C212.556 51.2531 211.525 49.7921 211.458 49.2424C211.3 47.9546 211.246 46.6489 211.295 45.3487C211.338 44.2181 211.479 43.0305 212.056 42.135C212.399 41.604 212.869 41.2166 213.333 40.8401C214.006 40.2945 214.699 39.7436 215.489 39.5164C216.85 39.1249 217.718 39.6634 216.555 40.887C215.721 41.7634 215.027 42.738 214.525 43.932Z",
    fill: "#3B455A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.01 65.5016C222.129 65.8301 220.247 66.1586 218.366 66.4871C217.994 64.5476 217.74 62.5698 217.607 60.579C215.946 60.342 213.982 59.8237 213.33 57.7912C213.125 57.1511 213.088 56.4431 213.054 55.7508C212.913 52.8881 212.773 50.0253 212.632 47.1626C212.584 46.1726 212.538 45.1518 212.782 44.2151C213.209 42.5715 214.43 41.5323 215.641 40.851C218.732 39.1125 222.415 38.9467 225.424 40.9623C226.225 41.499 226.989 42.2051 227.48 43.1981C228.236 44.7288 228.233 46.6766 228.204 48.4983C228.177 50.1798 228.15 51.8617 228.124 53.5436C228.093 55.4778 227.947 57.711 226.742 58.806C226.102 59.3872 225.25 59.5395 224.708 60.2741C223.754 61.5693 224.308 63.735 224.01 65.5016Z",
    fill: "#EACDB0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.698 57.4439C213.07 59.2083 213.862 60.8661 215.116 61.7928C216.537 62.8428 218.262 62.8176 219.893 62.7633C220.785 62.7336 221.677 62.7036 222.569 62.674C224.826 62.5986 227.054 62.1108 228.091 59.194C228.57 57.8489 228.674 56.3129 228.532 54.8388C228.493 54.4338 228.432 54.0183 228.256 53.6778C228.081 53.3373 227.765 53.0871 227.454 53.1591C227.058 53.251 226.84 53.7813 226.6 54.1979C226.076 55.1069 225.105 55.6559 224.284 55.2378C224.041 55.114 223.827 54.9175 223.613 54.7188C223.526 54.6374 223.438 54.5556 223.35 54.4784C222.467 53.713 221.413 53.4021 220.37 53.3035C219.464 53.2184 218.122 52.903 217.494 53.8626C217.128 54.421 216.763 54.9794 216.397 55.5374C216.247 55.7673 216.092 56.0016 215.891 56.1554C215.685 56.3136 215.442 56.3763 215.201 56.3965C214.596 56.4468 213.902 56.1539 213.665 55.4305C213.562 55.1155 213.56 54.7641 213.534 54.4244C213.509 54.0846 213.451 53.7258 213.265 53.4809C212.557 52.5438 212.43 54.112 212.426 54.6449C212.42 55.5858 212.507 56.533 212.698 57.4439ZM218.86 57.5579C219.599 58.0893 220.347 58.0506 221.127 57.7158C221.528 57.5436 221.735 58.3506 221.335 58.5224C220.394 58.9263 219.447 58.9476 218.559 58.309C218.19 58.0435 218.488 57.2905 218.86 57.5579Z",
    fill: "#3B455A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M211.42 39.1469C211.233 38.4625 211.086 37.7624 210.982 37.0533C211.543 37.2509 212.146 37.2756 212.717 37.1241C212.701 36.7124 212.684 36.3003 212.668 35.8885C212.656 35.5458 216.511 35.0673 216.824 35.017C219.752 34.5464 222.43 34.1054 225.17 35.833C227.511 37.3086 229.071 39.6318 229.555 42.751C230.016 45.7311 229.366 49.7005 228.025 52.2801C227.999 51.4806 228.301 49.5726 228.112 48.8234C227.982 48.0685 227.732 47.3485 227.4 46.69C226.738 45.3749 225.753 44.2949 224.637 43.5494C222.858 42.361 220.824 41.8 218.809 41.5896C216.962 41.3965 214.715 41.2521 212.928 41.9462C212.07 42.28 211.936 42.5508 211.364 41.5296C211.263 41.3496 210.432 39.2264 210.504 39.2204C210.81 39.196 211.115 39.1716 211.42 39.1469Z",
    fill: "#3B455A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.484 209.266L82.1953 208.922L84.7936 185.241L106.332 185.523L108.484 209.266Z",
    fill: "#C4C6C6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.043 191.795L106.795 190.653L107.427 197.626L84.043 191.795Z",
    fill: "black"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2109 75.2066V188.433C26.2109 190.29 27.4881 191.795 29.0634 191.795H161.837C163.412 191.795 164.689 190.29 164.689 188.433V75.2066C164.689 73.9845 163.849 72.9941 162.812 72.9941H28.0885C27.0516 72.9941 26.2109 73.9845 26.2109 75.2066Z",
    fill: "#CDD1D1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2109 75.191V177.101H164.689V75.191C164.689 73.8781 163.786 72.8142 162.673 72.8142H28.2279C27.1139 72.8138 26.2109 73.8781 26.2109 75.191Z",
    fill: "#3B455A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M161.041 77.5801H29.8633V171.552H161.041V77.5801Z",
    fill: "#F2F2F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.227 214.546H74.6758V209.093C74.6758 207.387 75.8489 206.004 77.2963 206.004H113.607C115.054 206.004 116.227 207.387 116.227 209.093V214.546Z",
    fill: "#CDD1D1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M161.041 84.7046H29.8633V131.268H161.041V84.7046Z",
    fill: "#F2F2F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6306 138.095H39.8594V162.692H75.6306V138.095Z",
    fill: "#9EA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.228 138.095H77.457V162.692H113.228V138.095Z",
    fill: "#9EA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.826 138.095H115.055V162.692H150.826V138.095Z",
    fill: "#9EA6AD"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.312 165.099H39.6016V167.746H59.312V165.099Z",
    fill: "#B3C1C4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1635 165.099H77.4531V167.746H97.1635V165.099Z",
    fill: "#B3C1C4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M134.761 165.099H115.051V167.746H134.761V165.099Z",
    fill: "#B3C1C4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7377 77.3792L40.9319 171.552H29.8633V77.5802L95.7377 77.3792Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6179 219.438L16.4356 221.932L15.0388 223.96C15.0388 223.96 14.6379 227.003 15.4015 227.537C16.1651 228.071 28.083 229.739 28.083 229.739L29.3111 227.58L28.326 225.195L22.0267 221.799L19.863 218.968L16.6179 219.438Z",
    fill: "#3B455A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0747 214.05L28.8924 216.544L27.5156 218.574C27.5156 218.574 27.1176 221.617 27.8682 222.151C28.6187 222.684 40.3428 224.332 40.3428 224.332L41.5538 222.171L40.5875 219.788L34.3934 216.403L32.268 213.575L29.0747 214.05Z",
    fill: "#3B455A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7353 170.525C15.7583 173.062 16.68 175.364 16.8468 178.632C17.0106 181.847 16.5006 185.048 16.114 188.235C14.7764 199.267 14.9078 210.464 15.0417 221.607C18.3031 221.774 21.5676 221.854 24.8319 221.846C25.3871 221.845 26.0126 221.806 26.382 221.318C26.7524 220.828 26.713 220.089 26.6512 219.438C25.9025 211.521 25.9547 203.511 26.0559 195.557C26.1059 191.64 26.2201 188.29 26.9016 184.51C27.5784 180.754 27.4578 176.863 27.2392 173.056C26.704 163.734 25.1014 154.584 24.66 145.265C24.5799 143.575 24.4443 141.758 23.5162 140.466C22.4003 138.914 20.4877 138.596 18.761 138.597C14.014 138.6 8.65709 139.482 8.41845 146.267C8.3389 148.529 8.8445 150.758 9.38159 152.931C10.612 157.911 11.9493 162.939 13.6535 167.726C14.0076 168.722 14.3777 169.638 14.7353 170.525Z",
    fill: "#305399"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9713 166.24C28.9469 168.834 29.8247 171.187 29.8588 174.461C29.8922 177.681 29.2103 180.849 28.6605 184.01C26.7575 194.951 26.4071 206.142 26.0619 217.279C29.518 217.635 32.9814 217.905 36.4483 218.087C37.0379 218.118 37.7039 218.115 38.1175 217.649C38.5321 217.182 38.5226 216.442 38.4856 215.787C37.9272 205.894 37.2979 195.97 37.8891 186.08C38.1153 182.295 38.5197 178.524 38.7007 174.736C39.053 167.359 38.5499 159.974 37.7869 152.646C37.317 148.133 37.9826 138.471 34.1081 135.739C32.354 134.502 30.1362 134.319 28.0855 134.689C27.0397 134.878 25.9957 135.209 25.1115 135.856C23.4076 137.103 22.5075 139.391 22.3239 141.645C22.1403 143.9 22.58 146.155 23.0551 148.357C24.1439 153.403 25.3441 158.503 26.9442 163.383C27.2777 164.398 27.6305 165.334 27.9713 166.24Z",
    fill: "#305399"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9719 81.3222C8.47324 83.0678 6.58611 85.7322 5.93161 89.6866C2.97538 107.545 4.80111 125.964 6.63543 144.03C6.76047 145.262 6.95361 146.638 7.80379 147.371C8.76629 148.201 10.1042 147.824 11.2481 147.427C20.246 144.306 29.4653 142.073 38.7778 140.759C38.215 127.475 37.1223 114.222 35.5047 101.059C35.0675 97.5005 34.5839 93.9136 33.4559 90.5731C30.9382 83.1147 26.6637 77.7987 19.4986 78.4898C16.459 78.7831 13.4216 79.6107 10.9719 81.3222Z",
    fill: "#7DB5DB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6618 63.8067C26.7837 66.0811 26.8772 68.5066 25.9125 70.4817C25.0906 72.1643 23.6273 73.2485 22.5035 74.6678C21.8187 75.5326 21.2495 76.6576 21.1213 77.8478C20.995 79.0227 21.5305 80.0251 21.5244 81.2007C21.5238 81.3106 21.52 81.4253 21.4761 81.5225C21.429 81.6263 21.3424 81.6968 21.2549 81.7527C20.8041 82.0411 20.2676 82.0516 19.7547 82.055C19.1489 82.0591 18.4871 82.1547 17.8867 82.0681C17.1014 81.9548 17.2611 81.7677 17.187 80.825C17.0766 79.4187 16.9152 78.0072 16.5302 76.6643C15.7357 73.8931 14.0449 71.5257 13.5657 68.6213C13.0357 65.408 13.8279 62.2587 14.6927 59.2032C15.0797 57.8363 15.5041 56.4428 16.2992 55.3482C18.0461 52.9426 22.1433 52.1742 24.1011 54.632C26.427 57.5528 26.4553 59.9472 26.6618 63.8067Z",
    fill: "#FEE4D6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0428 62.2471C27.3114 64.2965 27.5176 67.1888 26.557 69.4591C28.0312 68.2463 28.7248 66.0867 29.022 63.9972C29.1855 62.8478 29.2543 61.6737 29.1423 60.5157C28.7888 56.8602 26.3298 53.4815 23.2352 52.9962C21.1883 52.6752 21.1963 55.751 21.9943 57.2472C23.0433 59.2156 24.8891 60.3833 26.0428 62.2471Z",
    fill: "#3B455A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6209 51.0855C19.4741 50.4387 18.1489 50.4015 16.8822 50.529C15.1465 50.7038 11.6545 51.3079 9.59236 52.8319C8.42941 49.9013 5.0729 47.6862 2.62354 49.2064C1.18918 50.0967 0.568402 52.032 1.23054 53.5489C1.39599 53.9277 1.63209 54.2802 1.93913 54.5652C2.19654 54.804 2.50358 54.9957 2.72345 55.2672C3.55708 56.2962 2.78581 57.7564 2.17236 58.9204C1.47968 60.2348 1.00463 61.6557 0.770448 63.1125C0.638402 63.9345 0.587814 64.8015 0.907269 65.5744C1.22672 66.3469 2.00309 66.9949 2.86377 66.951C4.42159 66.8715 4.73563 65.3074 4.81645 63.8862C4.90936 62.2493 5.14322 60.813 5.77322 59.2879C6.0039 58.7292 6.31954 58.1404 6.82895 57.9807C6.92631 57.9503 7.02431 57.9383 7.12263 57.9387C6.78027 59.3059 6.59477 60.6915 6.77486 62.2133C7.13377 65.2463 8.08577 68.2039 9.6614 70.6392C11.237 73.074 13.451 74.9648 15.9544 75.7853C16.1316 73.9189 14.4612 72.5052 14.1573 70.6617C13.9928 69.6638 14.2534 68.6205 14.6966 67.7483C15.1399 66.876 15.7549 66.1459 16.3636 65.4255C17.4129 64.1835 18.4623 62.9415 19.5114 61.6995C20.3676 60.6863 21.2314 59.6614 21.8713 58.446C23.173 55.974 23.1122 52.4907 20.6209 51.0855Z",
    fill: "#3B455A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.262 84.334H157.086V131.474H157.262V84.334Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.083 84.334H156.879V131.474H157.083V84.334Z",
    fill: "#CFCFCF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.879 84.334H156.676V131.474H156.879V84.334Z",
    fill: "#CDCDCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.676 84.334H156.473V131.474H156.676V84.334Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.473 84.334H156.27V131.474H156.473V84.334Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.27 84.334H156.066V131.474H156.27V84.334Z",
    fill: "#C9C9C9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.067 84.334H155.863V131.474H156.067V84.334Z",
    fill: "#C7C7C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.864 84.334H155.66V131.474H155.864V84.334Z",
    fill: "#C6C6C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.661 84.334H155.457V131.474H155.661V84.334Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.458 84.334H155.254V131.474H155.458V84.334Z",
    fill: "#C3C3C3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.254 84.334H155.051V131.474H155.254V84.334Z",
    fill: "#C1C1C1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.051 84.334H154.848V131.474H155.051V84.334Z",
    fill: "#C0C0C0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.844 84.334H154.641V131.474H154.844V84.334Z",
    fill: "#BEBEBE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.641 84.334H154.438V131.474H154.641V84.334Z",
    fill: "#BDBDBD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.438 84.334H154.234V131.474H154.438V84.334Z",
    fill: "#BBBBBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.235 84.334H154.031V131.474H154.235V84.334Z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.032 84.334H153.828V131.474H154.032V84.334Z",
    fill: "#B9B9B9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.829 84.334H153.625V131.474H153.829V84.334Z",
    fill: "#B7B7B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.626 84.334H153.422V131.474H153.626V84.334Z",
    fill: "#B6B6B6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.422 84.334H153.219V131.474H153.422V84.334Z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.219 84.334H153.016V131.474H153.219V84.334Z",
    fill: "#B3B3B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.012 84.334H152.809V131.474H153.012V84.334Z",
    fill: "#B1B1B1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.809 84.334H152.605V131.474H152.809V84.334Z",
    fill: "#B0B0B0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.606 84.334H152.402V131.474H152.606V84.334Z",
    fill: "#AFAFAF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.403 84.334H152.199V131.474H152.403V84.334Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.2 84.334H151.996V131.474H152.2V84.334Z",
    fill: "#ACACAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.997 84.334H151.793V131.474H151.997V84.334Z",
    fill: "#AAAAAA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.793 84.334H151.59V131.474H151.793V84.334Z",
    fill: "#A9A9A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.59 84.334H151.387V131.474H151.59V84.334Z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.387 84.334H151.184V131.474H151.387V84.334Z",
    fill: "#A6A6A6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.184 84.334H150.98V131.474H151.184V84.334Z",
    fill: "#A5A5A5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.977 84.334H150.773V131.474H150.977V84.334Z",
    fill: "#A4A4A4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.774 84.334H150.57V131.474H150.774V84.334Z",
    fill: "#A2A2A2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.571 84.334H150.367V131.474H150.571V84.334Z",
    fill: "#A1A1A1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.368 84.334H150.164V131.474H150.368V84.334Z",
    fill: "#9F9F9F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.165 84.334H149.961V131.474H150.165V84.334Z",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.961 84.334H149.758V131.474H149.961V84.334Z",
    fill: "#9D9D9D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.758 84.334H149.555V131.474H149.758V84.334Z",
    fill: "#9B9B9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.555 84.334H149.352V131.474H149.555V84.334Z",
    fill: "#9A9A9A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.352 84.334H149.148V131.474H149.352V84.334Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.145 84.334H148.941V131.474H149.145V84.334Z",
    fill: "#979797"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.942 84.334H148.738V131.474H148.942V84.334Z",
    fill: "#969696"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.739 84.334H148.535V131.474H148.739V84.334Z",
    fill: "#959595"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.536 84.334H148.332V131.474H148.536V84.334Z",
    fill: "#939393"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.333 84.334H148.129V131.474H148.333V84.334Z",
    fill: "#929292"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.129 84.334H147.926V131.474H148.129V84.334Z",
    fill: "#919191"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.926 84.334H147.723V131.474H147.926V84.334Z",
    fill: "#909090"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.723 84.334H147.52V131.474H147.723V84.334Z",
    fill: "#8E8E8E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.52 84.334H147.316V131.474H147.52V84.334Z",
    fill: "#8D8D8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.317 84.334H147.113V131.474H147.317V84.334Z",
    fill: "#8C8C8C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.11 84.334H146.906V131.474H147.11V84.334Z",
    fill: "#8A8A8A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.907 84.334H146.703V131.474H146.907V84.334Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.704 84.334H146.5V131.474H146.704V84.334Z",
    fill: "#888888"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.501 84.334H146.297V131.474H146.501V84.334Z",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.297 84.334H146.094V131.474H146.297V84.334Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.094 84.334H145.891V131.474H146.094V84.334Z",
    fill: "#848484"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.891 84.334H145.688V131.474H145.891V84.334Z",
    fill: "#838383"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.688 84.334H145.484V131.474H145.688V84.334Z",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.485 84.334H145.281V131.474H145.485V84.334Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.282 84.334H145.078V131.474H145.282V84.334Z",
    fill: "#7F7F7F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.075 84.334H144.871V131.474H145.075V84.334Z",
    fill: "#7E7E7E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.872 84.334H144.668V131.474H144.872V84.334Z",
    fill: "#7C7C7C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.668 84.334H144.465V131.474H144.668V84.334Z",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.465 84.334H144.262V131.474H144.465V84.334Z",
    fill: "#7A7A7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.262 84.334H144.059V131.474H144.262V84.334Z",
    fill: "#797979"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.059 84.334H143.855V131.474H144.059V84.334Z",
    fill: "#787878"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.856 84.334H143.652V131.474H143.856V84.334Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.653 84.334H143.449V131.474H143.653V84.334Z",
    fill: "#757575"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.45 84.334H143.246V131.474H143.45V84.334Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.243 84.334H143.039V131.474H143.243V84.334Z",
    fill: "#737373"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.04 84.334H142.836V131.474H143.04V84.334Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.836 84.334H142.633V131.474H142.836V84.334Z",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.633 84.334H142.43V131.474H142.633V84.334Z",
    fill: "#6F6F6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.43 84.334H142.227V131.474H142.43V84.334Z",
    fill: "#6E6E6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.227 84.334H142.023V131.474H142.227V84.334Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.024 84.334H141.82V131.474H142.024V84.334Z",
    fill: "#6C6C6C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.821 84.334H141.617V131.474H141.821V84.334Z",
    fill: "#6A6A6A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.618 84.334H141.414V131.474H141.618V84.334Z",
    fill: "#696969"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.415 84.334H141.211V131.474H141.415V84.334Z",
    fill: "#686868"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.208 84.334H141.004V131.474H141.208V84.334Z",
    fill: "#676767"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.004 84.334H140.801V131.474H141.004V84.334Z",
    fill: "#666666"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.801 84.334H140.598V131.474H140.801V84.334Z",
    fill: "#656565"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.598 84.334H140.395V131.474H140.598V84.334Z",
    fill: "#646464"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.395 84.334H140.191V131.474H140.395V84.334Z",
    fill: "#626262"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.192 84.334H139.988V131.474H140.192V84.334Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.989 84.334H139.785V131.474H139.989V84.334Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.786 84.334H139.582V131.474H139.786V84.334Z",
    fill: "#5F5F5F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.583 84.334H139.379V131.474H139.583V84.334Z",
    fill: "#5E5E5E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.379 84.334H139.176V131.474H139.379V84.334Z",
    fill: "#5D5D5D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.172 84.334H138.969V131.474H139.172V84.334Z",
    fill: "#5C5C5C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.969 84.334H138.766V131.474H138.969V84.334Z",
    fill: "#5B5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.766 84.334H138.562V131.474H138.766V84.334Z",
    fill: "#5A5A5A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.563 84.334H138.359V131.474H138.563V84.334Z",
    fill: "#585858"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.36 84.334H138.156V131.474H138.36V84.334Z",
    fill: "#575757"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.157 84.334H137.953V131.474H138.157V84.334Z",
    fill: "#565656"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.954 84.334H137.75V131.474H137.954V84.334Z",
    fill: "#555555"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.75 84.334H137.547V131.474H137.75V84.334Z",
    fill: "#545454"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.547 84.334H137.344V131.474H137.547V84.334Z",
    fill: "#535353"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.34 84.334H137.137V131.474H137.34V84.334Z",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.137 84.334H136.934V131.474H137.137V84.334Z",
    fill: "#515151"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.934 84.334H136.73V131.474H136.934V84.334Z",
    fill: "#505050"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.731 84.334H136.527V131.474H136.731V84.334Z",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.528 84.334H136.324V131.474H136.528V84.334Z",
    fill: "#4E4E4E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.325 84.334H136.121V131.474H136.325V84.334Z",
    fill: "#4D4D4D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.122 84.334H135.918V131.474H136.122V84.334Z",
    fill: "#4C4C4C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.918 84.334H135.715V131.474H135.918V84.334Z",
    fill: "#4B4B4B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.715 84.334H135.512V131.474H135.715V84.334Z",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.512 84.334H135.309V131.474H135.512V84.334Z",
    fill: "#494949"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.305 84.334H135.102V131.474H135.305V84.334Z",
    fill: "#484848"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.102 84.334H134.898V131.474H135.102V84.334Z",
    fill: "#474747"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.899 84.334H134.695V131.474H134.899V84.334Z",
    fill: "#464646"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.696 84.334H134.492V131.474H134.696V84.334Z",
    fill: "#454545"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.493 84.334H134.289V131.474H134.493V84.334Z",
    fill: "#444444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.29 84.334H134.086V131.474H134.29V84.334Z",
    fill: "#434343"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.086 84.334H133.883V131.474H134.086V84.334Z",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.883 84.334H133.68V131.474H133.883V84.334Z",
    fill: "#414141"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.68 84.334H133.477V131.474H133.68V84.334Z",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.473 84.334H133.27V131.474H133.473V84.334Z",
    fill: "#3F3F3F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.27 84.334H133.066V131.474H133.27V84.334Z",
    fill: "#3E3E3E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.067 84.334H132.863V131.474H133.067V84.334Z",
    fill: "#3D3D3D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.864 84.334H132.66V131.474H132.864V84.334Z",
    fill: "#3C3C3C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.661 84.334H132.457V131.474H132.661V84.334Z",
    fill: "#3B3B3B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.458 84.334H132.254V131.474H132.458V84.334Z",
    fill: "#3A3A3A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.254 84.334H132.051V131.474H132.254V84.334Z",
    fill: "#393939"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.051 84.334H131.848V131.474H132.051V84.334Z",
    fill: "#383838"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.848 84.334H131.645V131.474H131.848V84.334Z",
    fill: "#383838"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.645 84.334H131.441V131.474H131.645V84.334Z",
    fill: "#373737"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.438 84.334H131.234V131.474H131.438V84.334Z",
    fill: "#363636"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.235 84.334H131.031V131.474H131.235V84.334Z",
    fill: "#353535"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.032 84.334H130.828V131.474H131.032V84.334Z",
    fill: "#343434"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.829 84.334H130.625V131.474H130.829V84.334Z",
    fill: "#3B455A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.625 84.334H130.422V131.474H130.625V84.334Z",
    fill: "#323232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.422 84.334H130.219V131.474H130.422V84.334Z",
    fill: "#313131"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.219 84.334H130.016V131.474H130.219V84.334Z",
    fill: "#313131"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.016 84.334H129.812V131.474H130.016V84.334Z",
    fill: "#303030"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.813 84.334H129.609V131.474H129.813V84.334Z",
    fill: "#2F2F2F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.61 84.334H129.406V131.474H129.61V84.334Z",
    fill: "#2E2E2E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.403 84.334H129.199V131.474H129.403V84.334Z",
    fill: "#2D2D2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.2 84.334H128.996V131.474H129.2V84.334Z",
    fill: "#2C2C2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.997 84.334H128.793V131.474H128.997V84.334Z",
    fill: "#2B2B2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.793 84.334H128.59V131.474H128.793V84.334Z",
    fill: "#2B2B2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.59 84.334H128.387V131.474H128.59V84.334Z",
    fill: "#2A2A2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.387 84.334H128.184V131.474H128.387V84.334Z",
    fill: "#292929"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.184 84.334H127.98V131.474H128.184V84.334Z",
    fill: "#282828"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.981 84.334H127.777V131.474H127.981V84.334Z",
    fill: "#272727"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.778 84.334H127.574V131.474H127.778V84.334Z",
    fill: "#272727"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.571 84.334H127.367V131.474H127.571V84.334Z",
    fill: "#262626"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.368 84.334H127.164V131.474H127.368V84.334Z",
    fill: "#252525"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.165 84.334H126.961V131.474H127.165V84.334Z",
    fill: "#242424"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.961 84.334H126.758V131.474H126.961V84.334Z",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.758 84.334H126.555V131.474H126.758V84.334Z",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.555 84.334H126.352V131.474H126.555V84.334Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 84.334H126.148V131.474H126.352V84.334Z",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.149 84.334H125.945V131.474H126.149V84.334Z",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.946 84.334H125.742V131.474H125.946V84.334Z",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.743 84.334H125.539V131.474H125.743V84.334Z",
    fill: "#1F1F1F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.536 84.334H125.332V131.474H125.536V84.334Z",
    fill: "#1E1E1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.333 84.334H125.129V131.474H125.333V84.334Z",
    fill: "#1E1E1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.129 84.334H124.926V131.474H125.129V84.334Z",
    fill: "#1D1D1D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.926 84.334H124.723V131.474H124.926V84.334Z",
    fill: "#1C1C1C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.723 84.334H124.52V131.474H124.723V84.334Z",
    fill: "#1B1B1B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.52 84.334H124.316V131.474H124.52V84.334Z",
    fill: "#1B1B1B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.317 84.334H124.113V131.474H124.317V84.334Z",
    fill: "#1A1A1A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.114 84.334H123.91V131.474H124.114V84.334Z",
    fill: "#191919"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.911 84.334H123.707V131.474H123.911V84.334Z",
    fill: "#191919"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.704 84.334H123.5V131.474H123.704V84.334Z",
    fill: "#181818"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.5 84.334H123.297V131.474H123.5V84.334Z",
    fill: "#171717"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.297 84.334H123.094V131.474H123.297V84.334Z",
    fill: "#171717"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.094 84.334H122.891V131.474H123.094V84.334Z",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.891 84.334H122.688V131.474H122.891V84.334Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.688 84.334H122.484V131.474H122.688V84.334Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.485 84.334H122.281V131.474H122.485V84.334Z",
    fill: "#141414"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.282 84.334H122.078V131.474H122.282V84.334Z",
    fill: "#141414"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.079 84.334H121.875V131.474H122.079V84.334Z",
    fill: "#131313"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.876 84.334H121.672V131.474H121.876V84.334Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.672 84.334H121.469V131.474H121.672V84.334Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.465 84.334H121.262V131.474H121.465V84.334Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.262 84.334H121.059V131.474H121.262V84.334Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.059 84.334H120.855V131.474H121.059V84.334Z",
    fill: "#101010"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.856 84.334H120.652V131.474H120.856V84.334Z",
    fill: "#101010"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.653 84.334H120.449V131.474H120.653V84.334Z",
    fill: "#0F0F0F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.45 84.334H120.246V131.474H120.45V84.334Z",
    fill: "#0E0E0E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.247 84.334H120.043V131.474H120.247V84.334Z",
    fill: "#0E0E0E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.043 84.334H119.84V131.474H120.043V84.334Z",
    fill: "#0D0D0D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.84 84.334H119.637V131.474H119.84V84.334Z",
    fill: "#0D0D0D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.633 84.334H119.43V131.474H119.633V84.334Z",
    fill: "#0C0C0C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.43 84.334H119.227V131.474H119.43V84.334Z",
    fill: "#0C0C0C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.227 84.334H119.023V131.474H119.227V84.334Z",
    fill: "#0B0B0B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.024 84.334H118.82V131.474H119.024V84.334Z",
    fill: "#0B0B0B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.821 84.334H118.617V131.474H118.821V84.334Z",
    fill: "#0A0A0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.618 84.334H118.414V131.474H118.618V84.334Z",
    fill: "#0A0A0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.415 84.334H118.211V131.474H118.415V84.334Z",
    fill: "#090909"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.211 84.334H118.008V131.474H118.211V84.334Z",
    fill: "#090909"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.008 84.334H117.805V131.474H118.008V84.334Z",
    fill: "#090909"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.805 84.334H117.602V131.474H117.805V84.334Z",
    fill: "#080808"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask195_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.598 84.334H117.395V131.474H117.598V84.334Z",
    fill: "#080808"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.395 84.334H117.191V131.474H117.395V84.334Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.192 84.334H116.988V131.474H117.192V84.334Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.989 84.334H116.785V131.474H116.989V84.334Z",
    fill: "#060606"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.786 84.334H116.582V131.474H116.786V84.334Z",
    fill: "#060606"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.583 84.334H116.379V131.474H116.583V84.334Z",
    fill: "#060606"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.379 84.334H116.176V131.474H116.379V84.334Z",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.176 84.334H115.973V131.474H116.176V84.334Z",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.973 84.334H115.77V131.474H115.973V84.334Z",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask204_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask204_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.766 84.334H115.562V131.474H115.766V84.334Z",
    fill: "#040404"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask205_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask205_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.563 84.334H115.359V131.474H115.563V84.334Z",
    fill: "#040404"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask206_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask206_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.36 84.334H115.156V131.474H115.36V84.334Z",
    fill: "#040404"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask207_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask207_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.157 84.334H114.953V131.474H115.157V84.334Z",
    fill: "#030303"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask208_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask208_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.954 84.334H114.75V131.474H114.954V84.334Z",
    fill: "#030303"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask209_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask209_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.751 84.334H114.547V131.474H114.751V84.334Z",
    fill: "#030303"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask210_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask210_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.547 84.334H114.344V131.474H114.547V84.334Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask211_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask211_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.344 84.334H114.141V131.474H114.344V84.334Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask212_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask212_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.141 84.334H113.938V131.474H114.141V84.334Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask213_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask213_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.938 84.334H113.734V131.474H113.938V84.334Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask214_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask214_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.731 84.334H113.527V131.474H113.731V84.334Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask215_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask215_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.528 84.334H113.324V131.474H113.528V84.334Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask216_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask216_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.325 84.334H113.121V131.474H113.325V84.334Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask217_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask217_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.122 84.334H112.918V131.474H113.122V84.334Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask218_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask218_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.918 84.334H112.715V131.474H112.918V84.334Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask219_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask219_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.715 84.334H112.512V131.474H112.715V84.334Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask220_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask220_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.512 84.334H112.309V131.474H112.512V84.334Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask221_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask221_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.309 84.334H112.105V131.474H112.309V84.334Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask222_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask222_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.106 84.334H111.902V131.474H112.106V84.334Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask223_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask223_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.903 84.334H111.699V131.474H111.903V84.334Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask224_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask224_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.696 84.334H111.492V131.474H111.696V84.334Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask225_6095_173364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 84,
    width: 128,
    height: 48
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M157.26 84.334H30.8086V131.474H157.26V84.334Z",
    fill: "white"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask225_6095_173364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.494 84.334H30.8086V131.474H111.494V84.334Z",
    fill: "black"
  })))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M153.166 80.3643H26.7148V127.505H153.166V80.3643Z",
    fill: "#305399"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0022 78.7098C34.9071 78.7214 34.8126 78.7413 34.72 78.772C33.8548 79.0611 33.6747 80.0984 32.9954 80.5938C32.6925 80.8146 31.6377 80.6354 31.7466 81.3198C31.7886 81.5718 31.8681 82.4354 31.9938 83.2956C31.8732 84.0078 31.7797 84.7278 31.6027 85.4234C31.1547 87.1836 28.4486 90.2793 30.0052 92.0121C30.3062 92.3474 30.6161 92.6894 30.9972 92.8802C31.3091 93.0362 31.6517 93.082 31.9893 93.1075C32.2525 93.1274 32.6664 93.2331 32.8602 93.034C33.0635 92.8247 33.1809 92.035 33.2789 91.7294C33.5596 90.8564 33.8399 89.9834 34.1205 89.1104C34.3957 88.2539 34.7874 87.2755 35.5501 87.1C35.7168 87.0618 35.8915 87.0666 36.0522 87.0017C36.2336 86.9286 36.3815 86.7734 36.5202 86.6174C37.0284 86.0455 37.5104 85.4114 37.8932 84.7135C38.577 83.4655 37.7971 81.3269 37.4344 80.0928C37.344 79.7856 37.2419 79.4706 37.0472 79.24C36.7309 78.865 36.246 78.7919 35.7992 78.7394C35.5345 78.7083 35.2647 78.6775 35.0022 78.7098Z",
    fill: "#E5D1BD"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1196 111.707C27.2947 109.767 28.2855 107.596 29.2429 105.948C31.8867 101.397 33.9669 96.404 35.3797 91.145C33.4874 89.5715 31.3286 88.4454 29.0682 87.8529C27.0003 91.9494 24.655 95.8509 22.0622 99.509C21.2982 100.587 19.7929 102.995 18.4152 101.735C17.796 101.169 17.5456 100.22 17.3292 99.3324C16.9216 97.6614 16.5137 95.99 16.1061 94.3187C15.4796 91.751 15.0278 88.6044 12.6529 87.6677C10.1338 86.6739 7.70356 88.5137 6.64147 91.2155C5.79829 93.3605 5.74165 95.813 5.85779 98.1733C6.19379 104.995 11.6016 110.044 15.5786 114.177C16.2461 114.871 16.9716 115.511 17.8007 115.892C21.596 117.634 24.123 115.004 26.1196 111.707Z",
    fill: "#7DB5DB"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M239.13 164.075C238.509 164.075 237.894 164.102 237.285 164.15C235.224 150.231 224.792 139.639 212.231 139.639C206.487 139.639 201.188 141.855 196.931 145.591C192.33 136.154 183.615 129.787 173.619 129.787C158.829 129.787 146.839 143.727 146.839 160.923C146.839 162.012 146.887 163.089 146.981 164.15C146.374 164.102 145.762 164.075 145.144 164.075C130.353 164.075 118.363 178.015 118.363 195.211C118.363 212.407 130.353 226.347 145.144 226.347H239.13C253.92 226.347 265.91 212.407 265.91 195.211C265.91 178.015 253.92 164.075 239.13 164.075Z",
    fill: "#D7E8F4"
  })), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.488 136.688C182.007 135.767 179.364 135.268 176.621 135.268C162.348 135.268 150.779 148.72 150.779 165.313C150.779 166.365 150.825 167.404 150.916 168.427C150.33 168.381 149.739 168.356 149.143 168.356C134.871 168.356 123.301 181.807 123.301 198.401C123.301 203.851 124.55 208.96 126.733 213.365C125.747 199.81 127.511 173.928 155.459 174.561C155.173 165.711 156.523 137.964 184.488 136.688Z",
    fill: "white"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.094 226.347H239.13C253.921 226.347 265.911 212.407 265.911 195.211C265.911 191.539 265.36 188.017 264.356 184.746C246.746 225.067 187.191 221.498 158.094 226.347Z",
    fill: "#3B455A"
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M173.793 102.972V107.534C173.793 109.016 174.787 110.218 176.014 110.218H185.933C187.159 110.218 188.153 109.016 188.153 107.534V102.972H173.793Z",
    fill: "#A5A5A5"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M205.025 41.7147C205.025 25.6647 194.257 12.6533 180.974 12.6533C167.69 12.6533 156.922 25.6647 156.922 41.7147C156.922 47.4184 158.283 52.7371 160.632 57.2258H160.631C167.324 70.7761 168.871 82.1254 168.871 82.1254H180.974H193.077C193.077 82.1254 194.623 70.7761 201.316 57.2258H201.315C203.664 52.7371 205.025 47.4184 205.025 41.7147Z",
    fill: "#587BC9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M168.594 82.1255V101.506C168.594 102.315 169.124 102.972 169.778 102.972H192.173C192.827 102.972 193.357 102.316 193.357 101.506V82.1255H168.594Z",
    fill: "#D6D5D4"
  })), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.598 36.2734C198.489 50.7049 186.624 72.9987 168.859 82.0467C168.866 82.0936 168.871 82.1251 168.871 82.1251H180.974H193.077C193.077 82.1251 194.624 70.7757 201.316 57.2254H201.315C203.665 52.7367 205.026 47.4181 205.026 41.7143C205.025 39.8543 204.875 38.0371 204.598 36.2734Z",
    fill: "#3B455A"
  }))), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.852 44.105C160.852 30.0927 170.253 18.7336 181.85 18.7336C188.628 18.7336 194.655 22.6156 198.494 28.6388C194.868 21.0331 188.073 15.9128 180.287 15.9128C168.69 15.9128 159.289 27.272 159.289 41.2842C159.289 47.1061 160.913 52.469 163.642 56.7503C161.867 53.0277 160.852 48.7096 160.852 44.105Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M176.299 82.1255L173.385 44.9255L177.445 49.0047L180.987 42.224L184.577 48.7883L188.569 44.8906L185.652 82.1255H186.895L190.076 41.4965L184.858 46.5923L180.963 39.4707L177.151 46.7671L171.871 41.4612L175.056 82.1255H176.299Z",
    fill: "#F6F7F7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M174.766 78.4156L175.056 82.1255H176.298L175.939 77.543C175.552 77.8396 175.16 78.131 174.766 78.4156Z",
    fill: "#EDECED"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M186.853 66.7943L185.652 82.1254H186.895L188.23 65.0674C187.779 65.6486 187.32 66.2243 186.853 66.7943Z",
    fill: "#EDECED"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M193.357 86.9375H168.594V90.5165H193.357V86.9375Z",
    fill: "#BAB9B9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M193.357 94.5808H168.594V98.1598H193.357V94.5808Z",
    fill: "#BAB9B9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M182.168 94.5808H193.355V90.5166H186.454C185.01 92.0597 183.575 93.4052 182.168 94.5808Z",
    fill: "#B5B3B0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M193.352 86.9375V82.1255H192.963C191.825 83.8741 190.674 85.4742 189.52 86.9375H193.352Z",
    fill: "#B5B3B0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M169.775 102.972H192.17C192.824 102.972 193.354 102.316 193.354 101.506V98.1597H177.185C173.906 100.15 170.954 101.257 168.633 101.872C168.765 102.503 169.224 102.972 169.775 102.972Z",
    fill: "#B5B3B0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M186.453 90.5165H193.354V86.9375H189.521C188.499 88.2335 187.474 89.4256 186.453 90.5165Z",
    fill: "#73726F"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M177.184 98.1598H193.353V94.5808H182.166C180.452 96.0129 178.779 97.1912 177.184 98.1598Z",
    fill: "#73726F"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M188.153 105.743C185.36 108.992 180.01 109.975 178.242 110.217H185.932C187.159 110.217 188.153 109.016 188.153 107.534V105.743Z",
    fill: "#8C8A89"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M199.761 93.5666L197.101 93.8888L195.322 92.0876L194.804 92.3475L195.038 93.1136L193.194 92.1278L191.599 92.6524L190.816 95.1026L191.482 97.6669L193.601 98.2958L196.117 97.4389L199.771 97.1854L199.761 93.5666Z",
    fill: "#EACDB0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M198.181 92.3348C200.987 91.3021 203.792 90.2697 206.597 89.237C208.408 88.5706 210.235 87.9455 212.034 87.236C214.296 86.3442 213.81 84.4823 215.26 82.3231C218.522 77.4646 222.177 72.3016 227.297 70.8983C227.808 70.7581 228.352 70.6602 228.851 70.8522C229.796 71.2152 230.274 72.5371 230.174 73.7022C230.073 74.8673 229.535 75.9076 229.003 76.8968C226.118 82.259 223.085 88.7791 219.23 93.2525C217.496 95.2636 213.742 95.2118 211.342 95.7001C206.487 96.6878 201.632 97.676 196.777 98.6641L198.181 92.3348Z",
    fill: "#305399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/Object.d6934f4b92af0cb70e2e82b05e744ea3.svg";
export { ForwardRef as ReactComponent };